import React from 'react';
import {Table} from "reactstrap";

class FollowupTable extends React.Component {

    getData = () => {
        var soldIDS = [];
        this.props.salesData.forEach(i => {
            if (soldIDS.indexOf(i.DealID) === -1) {
                soldIDS.push(i.DealID);
            }
        });

        var totalFollowups = 0;
        var processed = [];
        //its only a follow up if its not sold
        this.props.appointmentData.forEach( i => {
            if (processed.indexOf(i.DealID) == -1 && soldIDS.indexOf(i.DealID) == -1) {
                if (i.LogType != 7) {
                    totalFollowups++
                }
                processed.push(i.DealID)
            }
        });
        var processedSent = [];
        var propSent = 0;
        //proposal is sent as long as its not sold
        this.props.appointmentData.forEach(i => {
            if (processed.indexOf(i.DealID) == -1 && soldIDS.indexOf(i.DealID) == -1 && i.LogType == 4) {
                processedSent.push(i.DealID)
                propSent++;
            }
        })


        processed = [];
        var propNeeded = 0;
        //proposal is only needed if its not sent and not sold
        this.props.appointmentData.forEach(i => {
            if (processed.indexOf(i.DealID) == -1 && soldIDS.indexOf(i.DealID) == -1 && processedSent.indexOf(i.DealID) == -1 && i.LogType == 6) {
                processed.push(i.DealID)
                propNeeded++;
            }
        });


        return [
            {
                Name: 'Total Followups',
                Value: totalFollowups
            },
            {
                Name: 'Proposals Needed',
                Value: propNeeded
            },
            {
                Name: 'Proposals Sent',
                Value: propSent
            },
        ]
    }

    render() {
        const data = this.getData();
        return (
            <>
                <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                    <tr>
                        <th>&nbsp;</th>
                        <th className={`text-center`}>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    { data.map(d => {
                        return(

                            <tr key={d.Name}>
                                <td>{d.Name}</td>
                                <td className={`text-center`}>{d.Value}</td>
                            </tr>
                        )
                    })}

                    </tbody>
                </Table>
            </>
        )
    }
}

export default FollowupTable;